import AppBar from "@material-ui/core/AppBar"
import { useTheme } from "@material-ui/core/styles"
import Tab from "@material-ui/core/Tab"
import Tabs from "@material-ui/core/Tabs"
import useMediaQuery from "@material-ui/core/useMediaQuery"
import React, { useContext, useState } from "react"
import { CalculosContext } from "../../../contexts/CalculosContext"
import SiteContext from "../../../contexts/SiteContext"
import { ObterProdutosPaginado } from "../../../services/functions"

export default function CabecalhoCategorias() {
    const { aplicativoDados, estabelecimentoAtual, cardapio, carrinho, setCardapio } =
        useContext(SiteContext)

    const { adicionarQuantidadeZeroProdutos, apartirDe } = useContext(CalculosContext)

    const theme = useTheme()
    const mobile = useMediaQuery(theme.breakpoints.down("sm"))

    const [valueCategoria, setValueCategoria] = React.useState(0)

    const [posicaoOriginal, setPosicaoOriginal] = useState(null)

    const mudarCategoria = async (event, newValue) => {
        setValueCategoria(newValue)
    }

    const mudarCategoriaRequest = async (categoria, index) => {
        if (aplicativoDados.buscaProdutosPaginada) {
            // request categoria ObterProdutosPaginado
            const data = {
                idEstabelecimento: estabelecimentoAtual.id,
                idCategoria: categoria.id,
                start: 0,
                pesquisa: "",
                limit: 9999,
            }
            const response = await ObterProdutosPaginado(data, aplicativoDados)
            if (!response.codErro > 0) {
                cardapio.categorias.forEach((c, i) => {
                    if (i === index) {
                        c.produtos = response
                    } else {
                        c.produtos = []
                    }
                })
                apartirDe({ cardapio })

                if (estabelecimentoAtual.adicionarItensNaTelaInicial) {
                    adicionarQuantidadeZeroProdutos({ cardapio, carrinho })
                }

                setCardapio(cardapio)
                window.setTimeout(function () {
                    window.scrollTo(
                        0,
                        document.getElementById("categoria-" + categoria.id)?.offsetTop - 125
                    )
                }, 200)
            }
        }
    }

    window.onscroll = function scrollFunction() {
        const header = document.getElementById("cabecalhoDeCategorias")
        if (header) {
            const sticky = header.offsetTop
            // console.log('sticky', sticky)
            // console.log('posicaoOriginal', posicaoOriginal)
            // console.log('window.pageYOffset', window.pageYOffset)
            // console.log('window.pageYOffset > sticky && posicaoOriginal === null', window.pageYOffset > sticky && posicaoOriginal === null)
            // console.log('posicaoOriginal < sticky && posicaoOriginal !== null', posicaoOriginal < sticky && posicaoOriginal !== null)
            if (window.pageYOffset > sticky && posicaoOriginal === null) {
                console.log("sticky")
                header.classList.add("sticky")
                document.getElementById("divCatalago").style.paddingTop = header.offsetHeight
                    ? header.offsetHeight + "px"
                    : "48px"
                setPosicaoOriginal(window.pageYOffset)
            } else if (posicaoOriginal > window.pageYOffset && posicaoOriginal !== null) {
                console.log("no sticky")
                header.classList.remove("sticky")
                document.getElementById("divCatalago").style.paddingTop = ""
                setPosicaoOriginal(null)
            }
        }

        if (!aplicativoDados.buscaProdutosPaginada) {
            const categorias = document.getElementsByClassName("CardCategoriaCol")
            for (let i = valueCategoria - 1; i < categorias.length; i++) {
                const atual = window.scrollY
                const ultimo = categorias[categorias.length - 1]?.offsetTop - 130
                const inicio = categorias[i]?.offsetTop - 130
                const ate = categorias[i + 1]?.offsetTop - 130
                if (atual > inicio && atual < ate) {
                    setValueCategoria(i)
                    break
                } else if (atual > ultimo) {
                    setValueCategoria(categorias.length - 1)
                    break
                }
            }
        }
    }

    return (
        <AppBar
            position={mobile ? "relative" : "static"}
            color="default"
            id="cabecalhoDeCategorias"
        >
            <Tabs
                value={valueCategoria}
                onChange={mudarCategoria}
                indicatorColor="primary"
                textColor="primary"
                variant="scrollable"
                scrollButtons="auto"
                aria-label="scrollable auto tabs example"
            >
                {cardapio.categorias.map((categoria, index) =>
                    categoria.produtos.length > 0 || aplicativoDados.buscaProdutosPaginada ? (
                        <Tab
                            key={index}
                            onClick={() => {
                                if (!aplicativoDados.buscaProdutosPaginada) {
                                    window.scrollTo(
                                        0,
                                        document.getElementById("categoria-" + categoria.id).offsetTop - 125
                                    )
                                }
                                mudarCategoriaRequest(categoria, index)
                            }}
                            label={categoria.nome}
                        />
                    ) : null
                )}
            </Tabs>
        </AppBar>
    )
}
